module.exports = __webpack_public_path__ + "static/img/tl.3c1ccf11.svg";